import ClearIcon from "@mui/icons-material/Clear";
import classNames from "classnames";

export default function PiDeleteButton(props: {
  onClick: () => void;
  size?: "default" | "small";
}) {
  const { onClick, size = "default" } = { ...props };
  return (
    <div
      className={classNames(
        "h-full text-creator-error flex justify-center items-center cursor-pointer hover:text-creator-error-hover",
        {
          "text-[32px]": size === "default",
          "text-[24px]": size === "small",
        }
      )}
      onClick={onClick}
    >
      <ClearIcon fontSize="inherit" color="inherit" />
    </div>
  );
}
